import {
   MedicalServiceWithPractitionersSimple,
   MedicalServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { TextPattern } from '@dreryk/watermelon';

export const searchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<MedicalServiceWithPractitionersSimple[]> =>
      performCqrsQuerySearch<MedicalServiceWithPractitionersSimple>(() => {
         const query = new MedicalServiceWithPractitionersSimpleQuery();
         query.name = searchText ? TextPattern.anywhereIgnoreCase(searchText) : TextPattern.any();
         return query;
      });
};

export const triggerLabelExtractor = (medicalService: MedicalServiceWithPractitionersSimple): string =>
   medicalService.name;
